import "./Lester04.css";
import img1 from "./../../../img/bg/bg-lester.jpg";

import location from "./../../../img/icons/location.png";
import phone from "./../../../img/icons/phone.png";

function Lester04() {
  return (
    <div className="Lester04 section">
      <div className="container">
        <div className="Lester04-box">
          <div className="Lester04-card">
            <p className="eyebrow green">WATERLOO | ONTARIO</p>
            <h2>Lester Street</h2>
            <p>
              Located in the heart of Waterloo's vibrant north end, our flagship
              barbershop is where the Razor King journey began. Visit us for
              classic cuts and a timeless barbershop atmosphere.
            </p>

            <div className="divider"></div>

            <div className="Lester04-card-list">
              <img src={location} alt="" />
              <p>256 Lester St, Waterloo, ON, Canada</p>
            </div>

            <div className="Lester04-card-list">
              <img src={phone} alt="" />
              <p>(226) 988-1908</p>
            </div>

            <a
              href="https://bookings.gettimely.com/razorkingbarbershop/book"
              target="_blank"
              rel="noopener noreferrer"
              className="btn-3"
            >
              BOOK NOW
            </a>
          </div>

          <img src={img1} alt="" />
        </div>
      </div>
    </div>
  );
}

export default Lester04;
